import { MakeCall } from './createMakeCall';
import { PayoutMethods } from './types';

export default (makeCall: MakeCall) => () =>
  makeCall<PayoutMethods>('GET', `/api/v2/user/me/payout-methods`);
